subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    const priceElement = document.getElementById("header-cart-amount");
    if (!priceElement) return; // Element doesn't exist on /cart page

    const currencySymbol = priceElement.innerHTML[0];

    if(event.source === 'product-form') {
        const oldTotalAmount = parseFloat(priceElement.innerHTML.slice(1));
        const addedFinalAmount = event.cartData.final_price / 100;

        const newTotalAmount = (oldTotalAmount + addedFinalAmount).toFixed(2);
        const displayMoney = `${currencySymbol}${newTotalAmount}`;

        priceElement.innerHTML = displayMoney
    } else {
        const newTotalAmount = (event.cartData.total_price / 100).toFixed(2);
        const displayMoney = `${currencySymbol}${newTotalAmount}`;

        priceElement.innerHTML = displayMoney
    }
});